import type { TColorUpdateHelperArgs } from './types';

export const getBackgroundCoreColor = (color: TColorUpdateHelperArgs) => {
  switch (color) {
    case 'eggplant':
    case 'sage':
      return 'eggplant';
    case 'violet':
    case 'lavender':
      return 'violet';
    case 'poppy':
      return 'poppy';
  }
};

export const getHeadlineClassNames = (
  style: 'quoteLarge' | 'quoteLargeWhite' | 'quoteSmall' | 'quoteSmallWhite',
) => {
  switch (style) {
    case 'quoteLarge':
    case 'quoteLargeWhite':
      return ['editorialHeadline', 'quoteLarge'];
    case 'quoteSmall':
    case 'quoteSmallWhite':
    default:
      return ['editorialHeadline'];
  }
};
